import { type Dispatch, Store } from 'redux';

import { TagPayload } from '@/features/PCP/containers/FilterTagsContainer';

export const SET_PRICE_FILTER_RANGE = 'SET_PRICE_FILTER_RANGE';
export const DELETE_PRICE_FILTER_RANGE = 'DELETE_PRICE_FILTER_RANGE';

export interface SetPriceFilterRangesProps {
  key: string;
  max?: number;
  min?: number;
}

export const setPriceFilterRange = (value: SetPriceFilterRangesProps) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: SET_PRICE_FILTER_RANGE,
      payload: value,
    });
  };
};

export function deleteFilterPriceRange(payload: TagPayload) {
  return (dispatch: Dispatch, getState: () => Store) => {
    const state = getState() as any;

    dispatch({
      type: DELETE_PRICE_FILTER_RANGE,
      payload: {
        tag: payload,
        priceRanges: state.pages.pcp.facets.priceRange,
      },
    });
  };
}
